import PeriodsApi from '../../api/PeriodsApi'
import { DEFAULT_PERIOD_VALUE } from '../../constants/periods'
import { DELETE_PERIOD, SET_PERIODS } from '../types'

export const getAllPeriods = () => {
  return async (dispatch) => {
    
    try {
      const api = new PeriodsApi();

      const periods = parsePeriods( await api.list({ order: 'desc' }) );

      dispatch(setAllPeriods(periods))

    } catch (error) {
      console.error('error',error)
    }

  }
}

/**
 * Parse the API periods list for its use throughout the App.
 * @param {Array} list Periods list from the API.
 * @returns {Array}
 */
const parsePeriods = (list) => (
  list.map((period) => {
    // For form fields.
    [period.year, period.half] = period.nombre.split('-').map(part => Number(part));
    
    // For the <select /> component.
    period.label = period.nombre;
    period.value = period.abierto_para_inscripciones ? DEFAULT_PERIOD_VALUE : period.id;

    return period;
  })
)

export const deleteFromList = (slug) => {
  return (dispatch) => {
    dispatch({
      type: DELETE_PERIOD,
      payload: slug
    })
  }
}


const setAllPeriods = payload => ({ type: SET_PERIODS, payload })